





































































































import { defineComponent, ref, inject, onMounted, watch } from '@vue/composition-api'
import Button from '../components/parts/Button.vue'
import CapturePose from '../components/CapturePose.vue'
import Steppers from '../components/parts/Steppers.vue'
import OutPutCard from '../components/OutPutCard.vue'
import ShowBlock from '../components/ShowBlock.vue'
import { key } from '../store'

export default defineComponent({
  name: 'ProgrammerCamera',
  components: {
    Button,
    CapturePose,
    Steppers,
    OutPutCard,
    ShowBlock,
  },
  setup() {
    const store = inject(key)
    const root = ref()
    let resetKey = ref(0)
    let tableHeightRef = ref('')
    let blockHeightRef = ref('')
    const blockImgs: { [key: string]: string } = {
      ヒト: '/img/pose_blocks/table_pose_human.png',
      ライオン: '/img/pose_blocks/table_pose_lion.png',
      トリ: '/img/pose_blocks/table_pose_bird.png',
      ウサギ: '/img/pose_blocks/table_pose_rabbit.png',
    }
    const cameraMusic = new Audio('./sound/camera_sound.mp3')
    const renewMusic = new Audio('./sound/other_sound.mp3')
    cameraMusic.volume = 0.2
    renewMusic.volume = 0.2
    if (!store) {
      throw new Error('')
    }
    const caputurePoseRef = ref<InstanceType<typeof CapturePose>>()
    let resultPoses = ref<string[]>([])

    function judgePose() {
      cameraMusic.play()
      if (caputurePoseRef.value) {
        const posePredict = caputurePoseRef.value.judgePose()
        if (posePredict.className !== '背景') {
          resultPoses.value.push(posePredict.className)
          store?.setPredictedPoses(resultPoses.value)
        }
      }
    }

    function deletePosePredict() {
      resultPoses.value.splice(0, resultPoses.value.length)
      store?.setPredictedPoses(resultPoses.value)
    }

    const resizeTable = () => {
      if (root.value) {
        tableHeightRef.value = root.value.clientHeight - 48 - 16 - 16 + 'px'
      }
    }
    const resizeBlock = () => {
      if (root.value) {
        blockHeightRef.value = root.value.clientHeight - 48 - 16 + 'px'
      }
    }
    onMounted(() => {
      resizeTable()
      resizeBlock()
      cameraMusic.load()
      renewMusic.load()
    })

    const changeCameraMode = () => {
      renewMusic.play()
      store.switchCameraMode()
      resetKey.value++
    }

    return {
      blockImgs,
      caputurePoseRef,
      judgePose,
      resultPoses,
      store,
      root,
      tableHeightRef,
      blockHeightRef,
      resizeFunc: () => {
        resizeTable()
        resizeBlock()
      },
      deletePosePredict,
      isShowMsg: true,
      resetKey,
      changeCameraMode,
      dialog: true,
    }
  },
})
